import React from "react";
import Image from "next/image";
import Remote from "../../LoaderRemote";
import DefaultCurrencyFormat from "../../DefaultCurrencyFormat";
import { useTranslation } from "../../../context/TranslationContext";

const Right = ({ paymentDetails }) => {
  const { cleaningFee, PayByCreditCardRightTitle } = useTranslation();
  return (
    <div className="flex flex-col lg:w-1/2 order-1 lg:order-2 items-center lg:items-start">
      <div className="relative w-full h-56 sm:w-[25.563rem] sm:h-[13.125rem] rounded mb-[1.188rem] overflow-hidden">
        <Image
          src={paymentDetails.resim}
          objectFit={"cover"}
          objectPosition={"center"}
          loader={Remote}
          layout={"fill"}
          alt={paymentDetails.title}
        ></Image>
      </div>
      <div className="flex flex-col mb-3 items-center lg:items-start">
        <span className="font-bold text-[1.25rem] leading-7	text-[#333738] pb-[0.125rem]">
          {paymentDetails.baslik}
        </span>
        <span className="text-[1.5rem] text-[#333738] leading-[2.063rem] font-bold">
          <DefaultCurrencyFormat
            value={paymentDetails.toplam_tutar}
            Symbol={paymentDetails.Symbol}
          />
        </span>
      </div>
      <div className="flex flex-col items-center lg:items-start">
        <span className="text-13 text-[#A2B2B8] font-medium leading-6">
          {PayByCreditCardRightTitle.replace("{night}", paymentDetails.gece)}
        </span>
        <span className="text-13 text-[#A2B2B8] font-medium leading-6">
          {cleaningFee} : {paymentDetails.temizlik}
        </span>
      </div>
      <div className="self-center lg:self-end mt-2 lg:mt-auto">
        <Image src={"/images/visamaster.png"} width={128} height={51} />
      </div>
    </div>
  );
};

export default Right;
